<template>
  <div class="tabsContent1">

    <div class="main-con">

      <div class="table-con" >
        <table style="border: 1px solid rgb(225, 235, 240); border-collapse: collapse;width: 100%;">

          <tr class="tab-img">
            <td>馈线电压</td>
            <td>负荷电流</td>
            <td>基波电流</td>
            <td>谐波电流</td>
            <td>剩余电流	</td>
            <td>剩余基波电流</td>
            <td>剩余谐波电流</td>
            <td>绝缘电阻</td>
            <td>负荷功率</td>
            <td>负荷功率因数</td>
            <td>负荷无功功率</td>
            <td>剩余功率</td>
            <td>电度</td>
            <td>频率</td>
          </tr>
          <tr>
            <td>{{ alldata.U.value?alldata.U.value:"-" }}</td>
            <td>{{ alldata.Ifh.value?alldata.Ifh.value:"-" }}</td>
            <td>{{ alldata.Ifb.value?alldata.Ifb.value:"-" }}</td>
            <td>{{ alldata.Ifx.value?alldata.Ifx.value:"-" }}</td>
            <td>{{ alldata.Ires.value?alldata.Ires.value:"-" }}</td>
            <td>{{ alldata.Ireb.value?alldata.Ireb.value:"-" }}</td>
            <td>{{ alldata.Irex.value?alldata.Irex.value:"-" }}</td>
            <td>{{ alldata.Rres.value?alldata.Rres.value:"-" }}</td>
            <td>{{ alldata.Pfh.value?alldata.Pfh.value:"-" }}</td>
            <td>{{ alldata.PF.value?alldata.PF.value:"-" }}</td>
            <td>{{ alldata.Q?alldata.Q.value:alldata.Qfh?alldata.Qfh.value:"-" }}</td>
            <td>{{ alldata.Pres.value?alldata.Pres.value:"-" }}</td>
            <td>{{ alldata.W?alldata.W.value:alldata.Wp?alldata.Wp.value:"-" }}</td>
            <td>{{ alldata.Frequency?alldata.Frequency.value:"-" }}</td>
          </tr>
          <tr></tr>
          <tr></tr>
          <tr></tr>
        </table>
      </div>
    </div>


  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Vue from "vue";

export default {
  name: "tabsContent1",
  data() {
    return {
      loginName:null,
      branchId:null,
      activeName:"first",
      intervalId:'',
      showtab:false,
      alldata:{
        branchName: null,
        electricity: null,
        feederCurrent: null,
        frequency: null,
        fundamentalCurrent: null,
        harmonicCurrent: null,
        insulationResistance: null,
        loadCurrent: null,
        loadPower: null,
        loadPowerFactor: null,
        loadReactivePower: null,
        onOffState: null,
        remainingPower: null,
        residualCurrent:null,
        residualFundamentalCurrent: null,
        FundamentalWavecurrent: null,
        residualHarmonicCurrent: null,
      },

    };

  },
  mounted() {

    let that=this
    this.loginName=localStorage.getItem('loginName');
    this.gettabledata()
  },
  methods: {
    handleClick(){},
    gettabledata(){

      let that = this;
      let param = {};
      param.method="get";
      param.url="/analogData/analogDataInfo";
      param.params={
        "monitorSiteId":sessionStorage.getItem("saveid"),
        // "branchId":"000000123B28888-01",

      }
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          that.alldata=res.data
          that.showtab=true

        }else{

        }

      })
    },

  },
  watch: {

  },
  destroyed() {

  },
  components: {

  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent1{
  height: 100%;

  padding:10px;
  .main-con{
    background-color: #fff;
    height: calc(100% - 110px);
    width: calc(100% - 20px);
    padding:10px;
    margin-top: 10px;
  }
  .sb-dir{
    width: 300px;
    .sb-group{
      span{

        margin-right: 10px;

      }
    }
  }
  .top-con{
    width: calc(100% - 20px);
    height: 90px;
    display: flex;
    justify-content:flex-start;
    align-items:center;
    padding: 10px 20px 0 20px;
    line-height: 30px;
    background: #fff;
    .blue-name{
      display: inline-block;
      //background: url("../../../assets/station/bluebg.jpg") no-repeat;

      padding-left: 15px;
    }
    .blue-bor{
      background: #f0f5fc;
      border: 1px solid #a0c4f3;
      color: #306fd3;
      padding: 0 20px;

      height: 36px;
      line-height: 36px;
      margin-left: 20px;
      margin-top: 6px;
      font-size: 14px;
      display: inline-block;

      img{
        position: relative;
        top: 4px;
        margin-right: 10px;
      }
      .blue-item{
        margin-right: 20px;
      }
    }
  }
  .table-con{
    width: 100%;
    height:240px;
    td{
      text-align: center;
      border-bottom: 1px dashed #ddd;
      padding: 3px;
      height: 40px;
      background-color: rgba(0,0,0,0.02);
    }

    .tab-img{
      img{
        width: 40px;
        padding: 10px 0 4px;
      }

    }
  }
  .cav-con{
    height: calc(100% - 240px);
    padding-left: 10px;
    overflow: auto;
    box-sizing: border-box;
    position: relative;
    border: 1px solid #ddd;

  }
}
</style>
<style lang="less">
#app .tabsContent1 .search-blank {
  .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 175px;
  }
  .el-input__inner {
    width: 175px;
    height: 30px;
    line-height: 28px;
  }
  .el-input__icon {
    line-height: 28px;
  }
}
#app .tabsContent1 .el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #fff;
}
#app .tabsContent1 .el-select-dropdown__wrap{
  max-heigt:300px;
}
</style>
